(function () {
  'use strict';

  var RECENT_KEY        = 'sd_recent_searches';
  var POPULAR_KEY       = 'sd_popular_searches';
  var RECENT_MAX        = 6;
  var POPULAR_MAX       = 6;
  var POPULAR_MIN_COUNT = 2;

  function getRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; }
    catch { return []; }
  }

  function saveRecent(term) {
    if (!term || term.length < 2) return;
    let list = getRecent().filter(t => t.toLowerCase() !== term.toLowerCase());
    list.unshift(term);
    list = list.slice(0, RECENT_MAX);
    localStorage.setItem(RECENT_KEY, JSON.stringify(list));
  }

  function removeRecent(term) {
    const list = getRecent().filter(t => t !== term);
    localStorage.setItem(RECENT_KEY, JSON.stringify(list));
  }

  function clearRecent() {
    localStorage.removeItem(RECENT_KEY);
  }

  function getPopularRaw() {
    try { return JSON.parse(localStorage.getItem(POPULAR_KEY)) || {}; }
    catch { return {}; }
  }

  function trackPopular(term) {
    if (!term || term.length < 2) return;
    const data = getPopularRaw();
    const key  = term.toLowerCase();
    data[key]  = (data[key] || 0) + 1;
    localStorage.setItem(POPULAR_KEY, JSON.stringify(data));
  }

  function getPopularTerms() {
    const fromSettings = window.__popularSearchTerms__;
    if (fromSettings && fromSettings.length) return fromSettings;

    const data = getPopularRaw();
    return Object.entries(data)
      .filter(([, count]) => count >= POPULAR_MIN_COUNT)
      .sort((a, b) => b[1] - a[1])
      .slice(0, POPULAR_MAX)
      .map(([term]) => term.charAt(0).toUpperCase() + term.slice(1));
  }

  function saveSearch(term) {
    if (!term || term.length < 2) return;
    saveRecent(term);
    trackPopular(term);
  }

  function formatMoney(price, format) {
    if (!format) return price;
    const amount = parseFloat(price).toFixed(2);
    return format
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.floor(parseFloat(price)))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace(
        '{{amount_no_decimals_with_comma_separator}}',
        Math.floor(parseFloat(price)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      );
  }

  function initTypingPlaceholder(input) {
    if (!input) return;

    var placeholders = input.dataset.placeholders
      ? input.dataset.placeholders.split(',')
      : [];

    if (!placeholders.length) return;

    var currentIndex = 0;
    var currentChar  = 0;
    var isDeleting   = false;
    var timer        = null;

    function tick() {
      var current = placeholders[currentIndex];

      if (!isDeleting) {
        input.setAttribute('placeholder', current.slice(0, currentChar + 1));
        currentChar++;

        if (currentChar === current.length) {
          isDeleting = true;
          timer = setTimeout(tick, 1500);
          return;
        }
        timer = setTimeout(tick, 80);

      } else {
        input.setAttribute('placeholder', current.slice(0, currentChar - 1));
        currentChar--;

        if (currentChar === 0) {
          isDeleting   = false;
          currentIndex = (currentIndex + 1) % placeholders.length;
          timer = setTimeout(tick, 200);
          return;
        }
        timer = setTimeout(tick, 40);
      }
    }

    input.addEventListener('input', function () {
      if (input.value) {
        clearTimeout(timer);
        input.setAttribute('placeholder', '');
      } else {
        currentChar = 0;
        isDeleting  = false;
        tick();
      }
    });

    tick();
  }

  function initTrendingSwiper() {
    var el = document.querySelector('.search-drawer__swiper');
    if (!el) return;
    if (typeof Swiper === 'undefined') return;
    if (el.swiper) return;

    new Swiper(el, {
      slidesPerView: 2.3,
      spaceBetween: 16,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      navigation: {
        nextEl: '.search-drawer__swiper-next',
        prevEl: '.search-drawer__swiper-prev',
      },
      breakpoints: {
        480: { slidesPerView: 3.5 }
      }
    });
  }

  class SearchDrawer extends HTMLElement {

    connectedCallback() {
      this.drawerInner = this.querySelector('.search-drawer');
      this.overlay     = this.querySelector('[data-search-overlay]');
      this.input       = this.querySelector('[data-search-input]');
      this.results     = this.querySelector('[data-search-results]');
      this.empty       = this.querySelector('[data-search-empty]');
      this.closeBtn    = this.querySelector('[data-search-close]');
      this.openBtns    = document.querySelectorAll('[data-search-open]');

      this._timer     = null;
      this._lastQuery = '';
      this._abortCtrl = null;

      this._bindEvents();
    }

    open() {
      this.overlay     && this.overlay.classList.add('is-open');
      this.drawerInner && this.drawerInner.classList.add('is-open');
      this.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this.openBtns.forEach(btn => btn.setAttribute('aria-expanded', 'true'));
      setTimeout(() => { this.input && this.input.focus(); }, 100);
      setTimeout(() => initTrendingSwiper(), 50);
      this._showDefault();
    }

    close() {
      this.drawerInner && this.drawerInner.classList.remove('is-open');
      this.overlay     && this.overlay.classList.remove('is-open');
      this.classList.remove('is-open');
      document.body.style.overflow = '';
      this.openBtns.forEach(btn => btn.setAttribute('aria-expanded', 'false'));

      if (this._abortCtrl) { this._abortCtrl.abort(); this._abortCtrl = null; }
      this._lastQuery = '';

      setTimeout(() => {
        if (this.results) this.results.innerHTML = '';
        const trending = this.querySelector('[data-search-trending]');
        if (trending) trending.style.display = '';
        if (this.input) this.input.value = '';
      }, 400);
    }

    _bindEvents() {
      this.openBtns.forEach(btn => {
        btn.addEventListener('click', e => { e.preventDefault(); this.open(); });
      });

      this.closeBtn && this.closeBtn.addEventListener('click', () => this.close());

      this.overlay && this.overlay.addEventListener('click', e => {
        e.stopPropagation();
        this.close();
      });

      this.input && this.input.addEventListener('input', e => {
        const q = e.target.value.trim();
        if (q === this._lastQuery) return;
        this._lastQuery = q;
        clearTimeout(this._timer);

        if (q.length < 2) {
          if (this._abortCtrl) { this._abortCtrl.abort(); this._abortCtrl = null; }
          this._showDefault();
          return;
        }

        this._timer = setTimeout(() => this._fetch(q), 300);
      });

      const form = this.querySelector('form');
      form && form.addEventListener('submit', () => {
        const q = this.input && this.input.value.trim();
        if (q) saveSearch(q);
      });

      document.addEventListener('keydown', e => {
        if (!this.classList.contains('is-open')) return;
        if (e.key === 'Escape') this.close();
      });
    }

    _showDefault() {
      const trending = this.querySelector('[data-search-trending]');
      if (trending) trending.style.display = '';
      if (!this.results) return;
      if (this.empty) this.empty.style.display = 'none';
      this.results.innerHTML = '';

      const frag    = document.createDocumentFragment();
      const recent  = getRecent();
      const popular = getPopularTerms();

      if (recent.length) {
        const block = this._makeBlock('Son Aramalar', true);
        block.querySelector('.search-section-clear').addEventListener('click', e => {
          e.preventDefault();
          clearRecent();
          this._showDefault();
        });
        recent.forEach(term => {
          const chip = this._makeChip(term, () => {
            this.input.value = term;
            this._lastQuery  = term;
            this._fetch(term);
          });
          const del         = document.createElement('button');
          del.type          = 'button';
          del.className     = 'search-chip__remove';
          del.textContent   = '\u00d7';
          del.setAttribute('aria-label', 'Remove ' + term);
          del.addEventListener('click', e => {
            e.stopPropagation();
            e.preventDefault();
            removeRecent(term);
            this._showDefault();
          });
          chip.appendChild(del);
          block.querySelector('.search-chip-list').appendChild(chip);
        });
        frag.appendChild(block);
      }

      const popBlock = this._makeBlock('Popüler Anahtar Kelimeler', false);
      if (popular.length) {
        popular.forEach(term => {
          const chip = this._makeChip(term, () => {
            this.input.value = term;
            this._lastQuery  = term;
            this._fetch(term);
          });
          popBlock.querySelector('.search-chip-list').appendChild(chip);
        });
      } else {
        const hint       = document.createElement('p');
        hint.className   = 'search-popular-hint';
        hint.textContent = 'Popüler aramalar burada görünecektir.';
        popBlock.appendChild(hint);
      }
      frag.appendChild(popBlock);

      this.results.appendChild(frag);
    }

    _makeBlock(heading, showClear) {
      const wrap       = document.createElement('div');
      wrap.className   = 'search-section';

      const header     = document.createElement('div');
      header.className = 'search-section-header';

      const label       = document.createElement('span');
      label.className   = 'search-section-heading';
      label.textContent = heading;
      header.appendChild(label);

      if (showClear) {
        const clear       = document.createElement('button');
        clear.type        = 'button';
        clear.className   = 'search-section-clear';
        clear.textContent = 'Clear all';
        header.appendChild(clear);
      }

      const list     = document.createElement('div');
      list.className = 'search-chip-list';

      wrap.appendChild(header);
      wrap.appendChild(list);
      return wrap;
    }

    _makeChip(term, onClick) {
      const chip     = document.createElement('button');
      chip.type      = 'button';
      chip.className = 'search-chip';
      chip.addEventListener('click', onClick);

      const txt       = document.createElement('span');
      txt.className   = 'search-chip__text';
      txt.textContent = term;
      chip.appendChild(txt);

      return chip;
    }

    _fetch(q) {
      const trending = this.querySelector('[data-search-trending]');
      if (trending) trending.style.display = 'none';
      if (this._abortCtrl) this._abortCtrl.abort();
      this._abortCtrl = new AbortController();

      fetch(
        '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,article,page,query' +
        '&resources[limit]=5' +
        '&resources[limit_scope]=each',
        { signal: this._abortCtrl.signal }
      )
        .then(res => { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); })
        .then(data => {
          saveSearch(q);
          this._render((data && data.resources && data.resources.results) || {});
        })
        .catch(err => { if (err.name !== 'AbortError') console.error('[SearchDrawer]', err); });
    }

    _render(results) {
      if (!this.results) return;
      this.results.innerHTML = '';

      const sections = [
        {
          key:      'queries',
          label:    'Öneriler',
          getImg:   () => null,
          getTitle: i => i.text || i,
          getUrl:   i => '/search?q=' + encodeURIComponent(i.text || i),
        },
        {
          key:      'products',
          label:    'Ürünler',
          getImg:   i => i.featured_image && i.featured_image.url,
          getTitle: i => i.title,
          getUrl:   i => i.url,
          getMeta: i => {
            if (!i.price) return '';
            const s      = window.__ornixSettings || {};
            const format = s.showCurrencyCodes ? s.moneyWithCurrencyFormat : s.moneyFormat;
            return formatMoney(i.price, format);
          },
        },
        {
          key:      'collections',
          label:    'Koleksiyonlar',
          getImg:   i => i.featured_image && i.featured_image.url,
          getTitle: i => i.title,
          getUrl:   i => i.url,
        },
        {
          key:      'articles',
          label:    'Blog Yazıları',
          getImg:   i => i.image && i.image.url,
          getTitle: i => i.title,
          getUrl:   i => i.url,
        },
        {
          key:      'pages',
          label:    'Sayfalar',
          getImg:   () => null,
          getTitle: i => i.title,
          getUrl:   i => i.url,
        },
      ];

      let hasAny = false;
      const frag = document.createDocumentFragment();

      sections.forEach(section => {
        const items = results[section.key] || [];
        if (!items.length) return;
        hasAny = true;

        const heading       = document.createElement('div');
        heading.className   = 'search-section-heading';
        heading.textContent = section.label;
        frag.appendChild(heading);

        items.forEach(item => {
          const el     = document.createElement('a');
          el.href      = section.getUrl(item) || '#';
          el.className = 'search-result-item';

          const imgUrl = section.getImg(item);
          if (imgUrl) {
            const img   = document.createElement('img');
            img.src     = imgUrl;
            img.width   = 48;
            img.height  = 48;
            img.alt     = '';
            img.loading = 'lazy';
            el.appendChild(img);
          } else {
            const ph       = document.createElement('div');
            ph.className   = 'search-result-item__placeholder';
            ph.textContent = section.label.charAt(0);
            el.appendChild(ph);
          }

          const text     = document.createElement('div');
          text.className = 'search-result-item__text';

          const heading       = document.createElement('span');
          heading.className   = 'search-result-item__title';
          heading.textContent = section.getTitle(item);
          text.appendChild(heading);

          if (section.getMeta) {
            const meta = section.getMeta(item);
            if (meta) {
              const m       = document.createElement('span');
              m.className   = 'search-result-item__meta';
              m.textContent = meta;
              text.appendChild(m);
            }
          }

          el.appendChild(text);
          frag.appendChild(el);
        });
      });

      if (!hasAny) {
        if (this.empty) this.empty.style.display = 'flex';
        return;
      }

      if (this.empty) this.empty.style.display = 'none';

      const q           = this._lastQuery;
      const viewAll     = document.createElement('div');
      viewAll.className = 'search-view-all';

      const viewAllBtn       = document.createElement('a');
      viewAllBtn.href        = '/search?q=' + encodeURIComponent(q) + '&type=product,article,page';
      viewAllBtn.className   = 'btn btn--primary';
      viewAllBtn.textContent = 'Tüm sonuçları görüntüle "' + q + '"';
      viewAllBtn.addEventListener('click', () => saveSearch(q));

      viewAll.appendChild(viewAllBtn);
      frag.appendChild(viewAll);

      this.results.appendChild(frag);
    }
  }

  customElements.define('search-drawer', SearchDrawer);

  function init() {
    var input = document.querySelector('[data-search-input]');
    initTypingPlaceholder(input);

    var drawer = document.querySelector('[data-search-drawer]');
    if (drawer && drawer.dataset.popularTerms) {
      window.__popularSearchTerms__ = drawer.dataset.popularTerms
        .split(',')
        .map(function (t) { return t.trim(); })
        .filter(Boolean);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();